import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    text: '¿Quién autorizó ese cambio?',
    author: 'Nadie encontraba el mensaje'
  }, {
    text: 'Perdimos fotos clave porque cambiaron de celular.',
    author: 'Subcontratista'
  }, {
    text: 'Pasé 3 horas armando el informe semanal.',
    author: 'Constructor'
  }];
  return <section id="problema" className="scroll-mt-20 py-12 sm:py-20 bg-white" data-id="element-250">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-251">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider rounded-full mb-6" data-id="element-252">
          EL PROBLEMA
        </motion.div>

        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-[32px] sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-5 sm:mb-6 leading-[1.1] tracking-tight" data-id="element-253">
          Tu obra ya está documentada.{' '}
          <span className="text-blue-600" data-id="element-254">Solo se pierde.</span>
        </motion.h2>

        {/* Subhead */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-base sm:text-xl text-gray-600 max-w-2xl mx-auto mb-10 sm:mb-14 leading-relaxed" data-id="element-255">
          Las decisiones ya están en WhatsApp. El problema es que después nadie
          las encuentra.
        </motion.p>

        {/* Quote cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 text-left" data-id="element-256">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="relative bg-gray-50 border border-gray-200 rounded-2xl p-5 sm:p-7" data-id="element-257">
              <Quote className="w-5 h-5 sm:w-6 sm:h-6 text-blue-300 mb-3" data-id="element-258" />
              <p className="text-base sm:text-lg text-gray-900 font-medium leading-snug mb-4 sm:mb-5" data-id="element-259">
                "{problem.text}"
              </p>
              <p className="text-[11px] sm:text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-260">
                — {problem.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}